import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import UIAssetKeys from '../UIAssetKeys';
import { JButton } from '../ui/JButton';

export default class QuestionsContainer extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    super(scene);

    this.questionContainer = ABCyaPhaser.Images.addImage(this.scene.scale.width / 2, this.scene.scale.height / 2 + 90, UIAssetKeys._QuestionBckgDays, this);

    this.questionContainer.setInteractive({ hitArea: new Phaser.Geom.Rectangle(150,10, 650, 55), hitAreaCallback: Phaser.Geom.Rectangle.Contains });

    this.questionContainer.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.doClick, this);

    this.sunday = new JButton(this.scene, this.scene.scale.width / 2 - 382, this.scene.scale.height / 2 + 117, UIAssetKeys._SundayBtn).on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => this.buttonClicked(this.sunday));
    this.monday = new JButton(this.scene,this.scene.scale.width / 2 - 382 + 127, this.scene.scale.height / 2 + 117, UIAssetKeys._MondayBtn).on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => this.buttonClicked(this.monday));
    this.tuesday = new JButton(this.scene,this.scene.scale.width / 2 - 382 + (2 * 127), this.scene.scale.height / 2 + 117, UIAssetKeys._TuesdayBtn).on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => this.buttonClicked(this.tuesday));
    this.wednesday = new JButton(this.scene,this.scene.scale.width / 2 - 382 + (3 * 127), this.scene.scale.height / 2 + 117, UIAssetKeys._WednesdayBtn).on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => this.buttonClicked(this.wednesday));
    this.thursday = new JButton(this.scene,this.scene.scale.width / 2 - 382 + (4 * 127), this.scene.scale.height / 2 + 117, UIAssetKeys._ThursdayBtn).on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => this.buttonClicked(this.thursday));
    this.friday = new JButton(this.scene,this.scene.scale.width / 2 - 382 + (5 * 127), this.scene.scale.height / 2 + 117, UIAssetKeys._FridayBtn).on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => this.buttonClicked(this.friday));
    this.saturday = new JButton(this.scene,this.scene.scale.width / 2 - 382 + (6 * 127), this.scene.scale.height / 2 + 117, UIAssetKeys._SaturdayBtn).on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => this.buttonClicked(this.saturday));

    this.add([this.sunday, this.monday, this.tuesday, this.wednesday, this.thursday, this.friday, this.saturday]);

    this.sunday.setScale(0.8);
    this.monday.setScale(0.8);
    this.tuesday.setScale(0.8);
    this.wednesday.setScale(0.8);
    this.thursday.setScale(0.8);
    this.friday.setScale(0.8);
    this.saturday.setScale(0.8);

    this.enabled = true;
    this.doQuestionClick = () => {};
    this.doAction = (button) => {};
  }

  doClick () {
    if (!this.enabled) return;
    this.doQuestionClick();
  }

  buttonClicked (button) {
    if (!this.enabled) return;
    this.doAction(button);
  }

  enable () {
    JButton.enableAll();
    this.enabled = true;
  }

  disable () {
    JButton.disableAll();
    this.enabled = false;
  }
}